export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";